import { render, staticRenderFns } from "./ProductsInStockInternal.vue?vue&type=template&id=2bfafdec&scoped=true"
import script from "./ProductsInStockInternal.vue?vue&type=script&lang=js"
export * from "./ProductsInStockInternal.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStockInternal.vue?vue&type=style&index=0&id=2bfafdec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfafdec",
  null
  
)

export default component.exports